import { j as u } from "./jsx-runtime.DGlMoOmv.js";
import { u as T } from "./embla-carousel-react.esm.BE464U1q.js";
import { forwardRef as b, useState as y, useCallback as C, useEffect as S, createContext as M, useContext as K } from "react";
import { A as j } from "./ArrowButton.C_hYcEFL.js";
import { c as f } from "./index.CxSWpsOB.js";
const D = M(null);
function v() {
  const l = K(D);
  if (!l)
    throw new Error("useCarousel must be used within a <Carousel />");
  return l;
}
const B = ({
  className: l,
  totalItems: r
}) => {
  const {
    scrollTo: s,
    activeIndex: t
  } = v(), n = Math.min(r, 5), w = (e) => {
    s(e);
  }, m = (e) => {
    let o = "tw-w-6 tw-h-6 tw-bg-base-white tw-rounded-circular tw-mx-2", d = "tw-w-6 tw-h-6 tw-bg-base-white tw-rounded-circular tw-mx-2 tw-opacity-60", i = "tw-w-4 tw-h-4 tw-bg-base-white tw-rounded-circular tw-mx-2 tw-opacity-60";
    if (r < 5)
      return e === t ? o : d;
    if (t >= 2 && t < r - 2)
      return e === 2 ? o : e === 0 || e === 4 ? i : void 0;
    if (t < 2)
      return e === t ? o : e === 4 ? i : void 0;
    if (t === r - 2)
      return e === 3 ? o : e === 0 ? i : void 0;
    if (t === r - 1)
      return e === 4 ? o : e === 0 ? i : void 0;
    if (e === 0 || e === 4)
      return e === t ? o : i;
    if (e === t) return o;
  };
  return /* @__PURE__ */ u.jsx("div", { role: "tablist", "aria-label": "Carousel Navigation", className: f(l, "tw-flex tw-mb-12 tw-justify-center tw-relative tw-items-center"), children: Array.from({
    length: n
  }).map((e, o) => {
    const d = o === t, i = `carousel-slide-${o}`;
    return /* @__PURE__ */ u.jsx("button", { onClick: () => w(o), role: "tab", id: `carousel-tab-${o}`, "aria-selected": d, "aria-controls": i, "aria-label": `Slide ${o + 1} of ${n}`, tabIndex: d ? 0 : -1, className: f(m(o) || "tw-w-6 tw-h-6 tw-bg-base-white tw-rounded-circular tw-mx-2 tw-opacity-60", "tw-border-0 tw-cursor-pointer"), type: "button" }, o);
  }) });
};
B.displayName = "DotNavigation";
const L = b(({
  className: l,
  children: r,
  ...s
}, t) => {
  const {
    carouselRef: n,
    orientation: w
  } = v();
  return /* @__PURE__ */ u.jsx("div", { ref: n, className: "tw-h-full", children: /* @__PURE__ */ u.jsx("div", { ref: t, className: f("tw-flex", w === "horizontal" ? "-tw-ml-4" : "-tw-mt-4 tw-flex-col", l), ...s, children: r }) });
});
L.displayName = "CarouselContent";
const _ = b(({
  className: l,
  children: r,
  index: s = 0,
  ...t
}, n) => {
  const {
    activeIndex: w,
    orientation: m
  } = v();
  return /* @__PURE__ */ u.jsx("div", { ref: n, id: `carousel-slide-${s}`, role: "tabpanel", "aria-labelledby": `carousel-tab-${s}`, tabIndex: w !== s ? -1 : 0, className: f("tw-min-w-0 tw-shrink-0 tw-grow-0 tw-basis-full", m === "horizontal" ? "tw-pl-4" : "tw-pt-4", l), ...t, children: r });
});
_.displayName = "CarouselItem";
const q = b(({
  className: l
}, r) => {
  const {
    orientation: s,
    scrollPrev: t,
    canScrollPrev: n
  } = v();
  return n ? /* @__PURE__ */ u.jsx(j, { ref: r, className: f("tw-absolute tw-z-[5] tw-pointer-events-auto", s === "horizontal" ? "tw-left-12 tw-top-1/2 tw--translate-y-1/2" : "tw-top-12 tw-left-1/2 tw--translate-x-1/2 tw-rotate-90", l), onClick: t }) : null;
});
q.displayName = "CarouselPrevious";
const F = b(({
  className: l
}, r) => {
  const {
    orientation: s,
    scrollNext: t,
    canScrollNext: n
  } = v();
  return n ? /* @__PURE__ */ u.jsx(j, { ref: r, className: f("tw-absolute tw-z-[5] tw-pointer-events-auto", s === "horizontal" ? "tw-right-12 tw-top-1/2 tw--translate-y-1/2" : "tw-bottom-12 tw-left-1/2 tw--translate-x-1/2 tw-rotate-90", l), disabled: !n, onClick: t, right: !0 }) : null;
});
F.displayName = "CarouselNext";
const G = b(({
  orientation: l = "horizontal",
  opts: r = {},
  setApi: s,
  plugins: t,
  className: n,
  children: w,
  totalItems: m,
  startIndex: e,
  disableSwipe: o = !1,
  ...d
}, i) => {
  const [P, a] = T({
    axis: l === "horizontal" ? "x" : "y",
    startIndex: e || 0,
    watchDrag: !o,
    ...r
  }, t), [z, k] = y(!1), [I, $] = y(!1), [g, p] = y(0), h = C((c) => {
    c && (k(c.canScrollPrev()), $(c.canScrollNext()), p(c.selectedScrollSnap()));
  }, []), N = C(() => {
    p((c) => Math.max(c - 1, 0)), a?.scrollPrev();
  }, [a]), A = C((c) => {
    m && p((E) => Math.min(E + 1, m - 1)), a?.scrollTo(c);
  }, [a]), x = C(() => {
    p(g + 1), a?.scrollNext();
  }, [a]), R = C((c) => {
    c.key === "ArrowLeft" ? (c.preventDefault(), N()) : c.key === "ArrowRight" && (c.preventDefault(), x());
  }, [N, x]);
  return S(() => {
    !a || !s || s(a);
  }, [a, s]), S(() => {
    if (a)
      return h(a), a.on("reInit", h), a.on("select", h), () => {
        a?.off("select", h);
      };
  }, [a, h]), /* @__PURE__ */ u.jsx(D.Provider, { value: {
    carouselRef: P,
    api: a ?? null,
    opts: r,
    orientation: l || (r?.axis === "y" ? "vertical" : "horizontal"),
    scrollPrev: N,
    scrollNext: x,
    scrollTo: A,
    canScrollPrev: z,
    canScrollNext: I,
    activeIndex: g
  }, children: /* @__PURE__ */ u.jsx("div", { ref: i, onKeyDownCapture: R, className: f("tw-relative tw-w-full tw-overflow-hidden tw-touch-pan-y", n), role: "region", "aria-roledescription": "carousel", "data-testid": "carousel-component", ...d, children: w }) });
});
G.displayName = "Carousel";
export {
  G as C,
  B as D,
  L as a,
  _ as b,
  q as c,
  F as d
};
//# sourceMappingURL=Carousel.BZ3e8yYk.js.map
